import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const AgronomyRecommendationList = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
    },
  };

  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteHolidays } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Holidays detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
        };

        deleteHolidays(
          {
            url: "/api/bankDetail/",
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/farmerAgronomyRecommendationList?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    const filterText = e.target.value.trim().toLowerCase();

    const filterData = allData.filter(
      (item) =>
        (item.farmerName ?? "").toLowerCase().includes(filterText) ||
        (item.farmerNo ?? "").toLowerCase().includes(filterText) ||
        (item.regionName ?? "").toLowerCase().includes(filterText) ||
        (item.plotName ?? "").toLowerCase().includes(filterText) ||
        (item.cropName ?? "").toLowerCase().includes(filterText) ||
        (item.varietyName ?? "").toLowerCase().includes(filterText) ||
        (item.recommendation ?? "").toLowerCase().includes(filterText)
    );

    setData(filterData);
    setCurrentPage(1);
  };

  const [images, setImages] = useState();

  const openModal = (data) => {
    console.log(data);
    const Id = (data && data.agronomyId) || 0;

    getDetailView(
      {
        url: `/api/farmerAgronomyRecommendationList/?orgId=${localStorage.getItem(
          "orgId"
        )}&agronomyId=${Id}`,
      },
      (res) => {
        console.log("Detail View", res);
        setSelectedData(res);

        if ((selectedData.cropObservation ?? "") != "") {
          var cropObservationJs = JSON.parse(selectedData.cropObservation);
          console.log(
            "cropAttachment",
            cropObservationJs.cropObservationAttachment
          );
          var newimg = [];
          var cropAttachment = JSON.parse(
            cropObservationJs.cropObservationAttachment
          );
          cropAttachment.forEach((item) => {
            newimg = newimg.concat(item.urlAttachments);
          });
          console.log("newimg", newimg);
          setImages(newimg);
        }
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Agronomy Recommendation Details{" "}
            </label>{" "}
          </div>
          <div className="col-2"> </div>
          <div className="col-4 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Recommendation
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                        <br />
                      </div>
                      <br />
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th> Date </th>
                            <th> Farmer Name</th>
                            <th> Farmer No</th>
                            <th> Region Name</th>
                            <th> Plot Name</th>
                            <th> Crop Name</th>

                            <th> Variety Name</th>

                            <th> Recommendation</th>
                            <th> View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.date}</td>
                                <td>{x.farmerName}</td>
                                <td>{x.farmerNo}</td>
                                <td>{x.regionName}</td>
                                <td>{x.plotName}</td>
                                <td>{x.cropName}</td>
                                <td>{x.varietyName}</td>

                                <td>{x.recommendation}</td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Agronomy Recommendation Details</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => closeModal(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <label>Farmer Name</label> :{" "}
                    {selectedData && selectedData.farmerName}
                  </div>
                  <div className="col-md-6">
                    <label>Field Executive Name</label> :{" "}
                    {selectedData && selectedData.fieldExecutiveName}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Region Name</label> :{" "}
                    {selectedData && selectedData.regionName}
                  </div>
                  <div className="col-md-6">
                    <label>Plot Name</label> :{" "}
                    {selectedData && selectedData.plotName}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Plot Area</label> :{" "}
                    {selectedData && selectedData.plotArea}{" "}
                    {selectedData && selectedData.plotAreaUnit}
                  </div>

                  <div className="col-md-6">
                    <label>Crop Name</label> :{" "}
                    {selectedData && selectedData.cropName}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Variety Name</label> :{" "}
                    {selectedData && selectedData.varietyName}
                  </div>
                  <div className="col-md-6">
                    <label>Sowing Date</label> :{" "}
                    {selectedData && selectedData.sowingDate}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <label>Pruning Date</label> :{" "}
                    {selectedData && selectedData.pruningDate}
                  </div>
                  <div className="col-md-6">
                    <label>Harvesting Date</label> :{" "}
                    {selectedData && selectedData.harvestingDate}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Field Operation</label> :{" "}
                    {selectedData && selectedData.fieldOperationName}
                  </div>
                  <div className="col-md-6">
                    <label>Field Operation Date</label> :{" "}
                    {selectedData && selectedData.fieldOperationDate}
                  </div>
                </div>
                <div className="row"></div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Field Operation Description</label> :{" "}
                    {selectedData && selectedData.fieldOperationDescription}
                  </div>
                  <div className="col-md-6">
                    <label>Plant Count</label> :{" "}
                    {selectedData && selectedData.plantCount}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Average Leave Per Tree</label> :{" "}
                    {selectedData && selectedData.averageLeavesPerPlant}
                  </div>
                  <div className="col-md-6">
                    <label>Disease/Insect/Pest Observed</label> :{" "}
                    {selectedData && selectedData.insectDiseasePestName}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Affected Area</label> :{" "}
                    {selectedData && selectedData.affectedArea}
                  </div>
                  <div className="col-md-6">
                    <label>Recommendation</label> :{" "}
                    {selectedData && selectedData.recommendation}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <h6>Crop Observation</h6>
                    <div className="form-group">
                      {images &&
                        images.map((filePath, index) => (
                          <img
                            key={index}
                            alt={`Image ${index}`}
                            src={`${process.env.REACT_APP_FILE_URL}${filePath}`}
                            height="200"
                            width="200"
                            className="mx-2 my-2"
                          />
                        ))}
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </section>
      </Modal>
    </>
  );
};

export default AgronomyRecommendationList;
